import React, {
  useCallback,
  useMemo,
  useEffect,
  useState,
  useContext,
} from 'react';
import {
  Form,
  InputNumber,
  notification,
  Popconfirm,
  Spin,
  Button as AntButton,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { indexBy, setValueByNamePath, shouldUpdateCompare } from 'utils/utils2';
import {} from 'services/Document';
import {
  AddParMarketingAsset,
  ParMarketingAssetResponse,
  ParMarketingResponse,
  RemoveParMarketingAsset,
  UpdateParMarketingAsset,
} from 'services/assetconfig';

import { AssetCatalogResponse } from 'services/assetconfig';

import { useFormList } from 'hooks/useFormList';
import {
  AppstoreTwoTone,
  CloseOutlined,
  PlusOutlined,
  EditOutlined,
} from '@ant-design/icons';
import Button from 'components/Button';
import DeleteButton from 'components/DeleteButton';
import { AuthContext } from 'components/Auth/Auth';
import ParListSelect from 'components/ParListSelect';
import InputCurrency from 'components/InputCurrency';
import { toCurrency, toRate } from 'utils/utils';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ModalControllerNV from 'components/ModalControllerNV';
import AssetCatalogSearchModal from '../AssetCatalog/AssetCatalogSearchModal';
import UpdateButton from 'components/UpdateButtonAction';
import { Image } from 'antd';
import ModalController from 'components/ModalController';
import FormInput from 'components/FormInput';
import FormItem from 'antd/lib/form/FormItem';
import Value from 'components/Value';
import ImagePreviw from '../AssetCatalog/components/ImagePreview';
import AssetCatalogDetailsModal from '../AssetCatalog/AssetCatalogDetailsModal';
import { UPLOAD_IMG_URL } from 'utils/config';

export type ParMarketingAssetProps = {
  data: Array<AssetCatalogResponse>;
  marketingResponse: ParMarketingResponse;
  isFetching: any;
  refetch: () => void;
  catalogid?: number;
  idOrCreate?: string;
  mcid: number;
};

const ParMarketingAsset = ({
  data,
  isFetching,
  marketingResponse,
  refetch,
  idOrCreate,
  mcid,
}: ParMarketingAssetProps) => {
  const [form] = useForm();
  const fieldName = 'parmarketingAsset';
  const NEW_ID = -1;
  const [loading, setLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(idOrCreate === 'create');
  const id = !isCreate ? idOrCreate : undefined;
  const { isInspect } = useContext(AuthContext);

  const [editingKeys, setEditingKeys] = useState<number | null>();
  const isEditable = (id: number): boolean => editingKeys === id;

  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'catalogid',
  });
  const [State, setState] = useState({});
  useEffect(() => {
    if (marketingResponse) {
      let listassets = marketingResponse.assets.map((asset) => ({
        ...asset,
        cataloglabel: asset.assetlabel,
        assetpictureurl: asset.assetpictureurl,
        tpidparticipation: {
          tpid: asset.tpidparticipation,
          tpreference: asset.participantreference,
          tpname: asset.participantname,
        },

        currcode: asset.currcode,
      }));
      form.setFieldsValue({
        [fieldName]: listassets,
      });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
  }, [form, marketingResponse]);

  useState(false);
  const getName = useCallback(
    (name: string) => (record: AssetCatalogResponse) => {
      const marketingAsset = form.getFieldValue(fieldName);
      const index = indexBy(marketingAsset, 'catalogid')[record.catalogid];

      return [fieldName, index, name];
    },
    [form]
  );

  const addRow = useCallback(() => {
    const newItem: ParMarketingAssetResponse = {
      id: -1,
      mcid: '' as any,
      catalogid: '' as any,
      partmethod: '',
      partmethodlabel: '',
      partamount: '' as any,
      partrate: '' as any,
      tpidparticipation: '' as any,
      participantreference: '',
      participantname: '',
      partnbdays: '' as any,
      rolcode: '',
      rolcodelabel: '',
    };
    add(newItem);
    setEditingKeys(-1);
  }, [add]);

  const onSaveOrEdit = useCallback(
    (record: AssetCatalogResponse) => {
      const marketinga: ParMarketingAssetResponse[] =
        form.getFieldValue(fieldName);
      const index = indexBy(marketinga, 'catalogid')[record.catalogid];
      const currentValue = {
        ...marketinga[index],
      };
      const { id } = currentValue;

      id === NEW_ID
        ? AddParMarketingAsset({
            mcid: mcid,
            request: currentValue,
          }).then((response) => {
            if (response.code === '200') {
              refetch();
              notification.success({
                message: response.message,
              });
              setEditingKeys(null);
            }
          })
        : UpdateParMarketingAsset({
            mcid: mcid,
            request: {...currentValue,tpidparticipation:Number(currentValue.tpidparticipation)},
          }).then((response) => {
            if (response.code === '200') {
              notification.success({
                description: response.description,
                message: response.message,
              });
              refetch();
              setEditingKeys(null);
            } else {
              notification.error({
                description: response.description,
                message: response.message,
              });
            }
          });
    },

    [form, refetch, getName]
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'catalogid',
        render: (value, record, index) => {
          return (
            <Form.Item name={getName('catalogid')(record)} noStyle>
              {value}
              {record?.id === NEW_ID ? (
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <AntButton
                      icon={<AppstoreTwoTone />}
                      onClick={() => setVisible(true)}
                      size="small"
                      style={{ marginLeft: '9px' }}
                    />
                  )}
                  modal={({ setVisible, visible }) => (
                    <AssetCatalogSearchModal
                    status='ACTIVE'
                      visible={visible}
                      onCancel={() => {
                        setVisible(false);
                      }}
                      setAsset={(asset) => {
                        setValueByNamePath(
                          form,
                          getName('catalogid')(record),
                          asset.catalogid
                        );
                        setValueByNamePath(
                          form,
                          getName('cataloglabel')(record),
                          asset.assetlabel
                        );
                        setValueByNamePath(
                          form,
                          getName('currcode')(record),
                          asset.currcode
                        );
                        setValueByNamePath(
                          form,
                          getName('assetnetamount')(record),
                          asset.assetnetamount
                        );
                        setValueByNamePath(
                          form,
                          getName('assetpictureurl')(record),
                          asset.assetpictureurl
                        );

                        setVisible(false);
                        form.setFieldsValue({
                          catalogid: asset.catalogid,
                          cataloglabel: asset.assetlabel,
                          currcode: asset.currcode,
                          assetnetamount: asset.assetnetamount,
                          assetpictureurl: asset.assetpictureurl,
                        });
                      }}
                    />
                  )}
                ></ModalControllerNV>
              ) : (
                ''
              )}
            </Form.Item>
          );
        },
        width: 100,
      },
      {
        dataIndex: 'cataloglabel',
        render: (value, record) => {
          return record !== undefined ? (
            <Form.Item name={getName('cataloglabel')(record)} noStyle>
              <ModalController>
                {({ setVisible, visible }) => (
                  <>
                    <a onClick={() => setVisible(true)}>
                      {record?.assetlabel ?? record.cataloglabel}
                    </a>
                    <AssetCatalogDetailsModal
                      title={record.assetlabel + ' - ' + record.catalogid}
                      catalogid={record.catalogid}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                    />
                    {/* <AssetCatalogModal
                        title={record.assetlabel + ' - ' + record.catalogid}
                        ACid={Number(record.catalogid)}
                        asset={record}
                        visible={visible}
                        onCancel={() => setVisible(false)}
                      /> */}
                  </>
                )}
              </ModalController>
            </Form.Item>
          ) : (
            value
          );
        },
        width: 200,
      },
      {
        dataIndex: 'partmethodlabel',
        render: (value, record) => {
          return isEditable(record?.catalogid) || record.id === NEW_ID ? (
            <Form.Item name={getName('partmethod')(record)} noStyle>
              <ParListSelect
                parcode="CTEPARTMET"
                allowClear
                onChange={(e) => {
                  setValueByNamePath(form, getName('partnbdays')(record), '');
                }}
              />
            </Form.Item>
          ) : (
            <Value value={value} />
          );
        },
        width: 250,
      },
      {
        dataIndex: 'partamount',
        render: (value, record) =>
          record.partmethod !== 'NONE' ? (
            isEditable(record?.catalogid) || record.id === NEW_ID ? (
              <FormInput
                name={getName('partamount')(record)}
                noStyle
                hidden={form.getFieldValue('partmethod') === 'NONE'}
              >
                <InputCurrency
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  min={0}
                  step={1}
                  currcode={
                    form.getFieldValue('currcode')
                      ? form.getFieldValue('currcode')
                      : localStorage.getItem('currcode') ?? ''
                  }
                />
              </FormInput>
            ) : (
              <Form.Item shouldUpdate={shouldUpdateCompare('currcode')} noStyle>
                {toCurrency(value, record.currcode)}
              </Form.Item>
            )
          ) : (
            ''
          ),
        width: 150,
      },
      {
        dataIndex: 'partrate',
        render: (value, record) =>
          record.partmethod !== 'NONE' ? (
            isEditable(record.catalogid) || record.id === NEW_ID ? (
              <Form.Item name={getName('partrate')(record)} noStyle>
                <InputNumber
                  style={{ width: '90%' }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  formatter={toRate}
                  max={100}
                  min={0}
                  step={1}
                />
              </Form.Item>
            ) : (
              toRate(value)
            )
          ) : (
            ''
          ),
        width: 150,
      },
      {
        dataIndex: 'partnbdays',
        render: (value, record) =>
          record.partmethod === 'CREDF' ? (
            isEditable(record?.catalogid) || record.id === NEW_ID ? (
              <Form.Item name={getName('partnbdays')(record)} noStyle>
                <InputNumber
                  style={{ width: '90%' }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  min={0}
                  step={1}
                />
              </Form.Item>
            ) : (
              <Form.Item name={getName('partnbdays')(record)} noStyle>
                {record.partnbdays}
              </Form.Item>
            )
          ) : (
            ''
          ),
        width: 150,
      },
      {
        dataIndex: 'rolcodelabel',
        render: (value, record) =>
          record.partmethod !== 'NONE' ? (
            isEditable(record?.catalogid) || record.id === NEW_ID ? (
              <Form.Item name={getName('rolcode')(record)} noStyle>
                <ParListSelect
                  parcode="TPSERVROLE"
                  onChange={(e) => {
                    setValueByNamePath(
                      form,
                      getName('tpidparticipation')(record),
                      ''
                    );
                  }}
                />
              </Form.Item>
            ) : (
              <Form.Item name={getName('rolcode')(record)} noStyle>
                {record.rolcodelabel}
              </Form.Item>
            )
          ) : (
            ''
          ),
        width: 260,
      },
      {
        dataIndex: 'tpidparticipation',
        render: (value, record) => {
          return record.rolcode !== '' ? (
            isEditable(record.catalogid) || record.id === NEW_ID ? (
              <FormItem shouldUpdate={shouldUpdateCompare('rolcode')} noStyle>
                {({ getFieldValue }) => (
                  <FormInput
                    name={getName('tpidparticipation')(record)}
                    noStyle
                  >
                    <ThirdPartyInput
                      role={record.rolcode}
                      onlytpid
                      onChange={(e) => {
                        form.setFieldsValue({
                          tpidparticipation: e.tpid,
                          participantreference: e.tpreference,
                          participantname: e.tpname,
                        });
                      }}
                    />
                  </FormInput>
                )}
              </FormItem>
            ) : record.participantreference === null ? (
              ''
            ) : (
              <FormItem shouldUpdate={shouldUpdateCompare('rolcode')} noStyle>
                {({ getFieldValue }) => (
                  <FormInput
                    name={getName('tpidparticipation')(record)}
                    noStyle
                  >
                    <ThirdPartyInput
                      role={record.rolcode}
                      onlytpid
                      onChange={(e) => {
                        form.setFieldsValue({
                          tpidparticipation: e.tpid,
                          participantreference: e.tpreference,
                          participantname: e.tpname,
                        });
                      }}
                      disabled
                    />
                  </FormInput>
                )}
              </FormItem>
              // <Form.Item name={getName('tpidparticipation')(record)} noStyle>
              //   {record.participantreference + ' - ' + record.participantname}
              // </Form.Item>
            )
          ) : (
            ''
          );
        },
        width: 250,
      },

      {
        dataIndex: 'assetpictureurl',
        render: (value, record) => {
          const name = [
            fieldName,
            indexBy(form.getFieldValue(fieldName), 'catalogid')[
              record.catalogid
            ],
            'assetpictureurl',
          ];
          return isEditable(record.catalogid) || record.id === NEW_ID ? (
            <Image width={160} src={   UPLOAD_IMG_URL +record.assetpictureurl} />
          ) : (
            <ImagePreviw
              fieldName={fieldName}
              form={form}
              _record={record}
              name="assetpictureurl"
              getNameProps={getName}
            />
          );
        },
        width: 180,
      },
      {
        key: 'actions',
        comcode: 'actions',
        fixed: 'right',
        render: (_, record) => {
          return record.id === NEW_ID ? (
            <>
              <UpdateButton
                comcode="save"
                htmlType="button"
                size="middle"
                onClick={() => {
                  !isInspect && onSaveOrEdit(record);
                }}
              />
              <AntButton
                danger
                htmlType="button"
                icon={
                  <CloseOutlined height="14px" width="14px" color="white" />
                }
                onClick={() => {
                  !isInspect && remove(record.catalogid);
                }}
              />
            </>
          ) : editingKeys === record.catalogid ? (
            <>
              <UpdateButton
                comcode="update"
                htmlType="button"
                size="middle"
                onClick={(item) => {
                  item.preventDefault();
                  !isInspect && onSaveOrEdit(record);
                }}
              />
              <AntButton
                danger
                htmlType="button"
                icon={
                  <CloseOutlined height="14px" width="14px" color="white" />
                }
                onClick={() => {
                  !isInspect && setEditingKeys(null);
                }}
              />
            </>
          ) : (
            <>
              <Button
                htmlType="button"
                size="middle"
                comcode="edit"
                onClick={() => {
                  !isInspect && setEditingKeys(record.catalogid);
                }}
                icon={<EditOutlined />}
                style={{ width: '115px', height: '38px' }}
              />
              {/* <SaveButtonAction
                // onClick={(item) => {
                //   item.preventDefault();
                //   onSaveOrEdit(record);
                // }}
                htmlType="button"
                size="small"
                comcode="update"
              /> */}
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  remove(record.catalogid);
                  RemoveParMarketingAsset({
                    catalogid: record.catalogid,
                    mcid: mcid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                    refetch();
                  });
                }}
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            </>
          );
        },
        width: 200,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      getName,
      isFetching,
      onSaveOrEdit,
      refetch,
      marketingResponse,
      form,
      editingKeys,
    ]
  );

  return (
    <DF.Provider pagcode="parmarketingasset">
      <Spin spinning={loading}>
        <Form form={form}>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const marketing: AssetCatalogResponse[] =
                getFieldValue(fieldName);
              // marketing', marketing);

              const isNewItemInMarketingAsset =
                marketing?.find(({ id }) => id === NEW_ID) !== undefined;

              return (
                <DataGrid
                  rowKey={(item) => String(item.id)}
                  dataSource={marketing}
                  titleComcode="marketingAssetList"
                  columns={columns}
                  hideFilters
                  isLoading={isFetching}
                  extraActions={
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        !isInspect && addRow();
                      }}
                      style={{ flex: 'right' }}
                      comcode="Add"
                      disabled={isNewItemInMarketingAsset}
                    />
                  }
                />
              );
            }}
          </Form.Item>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default ParMarketingAsset;
